module.exports = __webpack_public_path__ + "img/cold-dish.76167874.svg";